import './_header.scss';
import React from "react";
import Navigation from '../../components/Navigation/navigation';

function Header() {
    return (
        <header>
            <a href="/"><h1>Arthur Le Meur</h1></a>
            <Navigation />
        </header>
    )
}

export default Header;